export const getProjectsInEngagement = (projectList, engagementId) =>
  projectList.filter(project => project.engagementId === engagementId);



// WEBPACK FOOTER //
// ./src/state/projects/selectors.js